import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <h2 style={{ color: '#3b82f6', marginBottom: '40px', fontSize: '22px' }}>Email AI</h2>
      
      <nav style={{ display: 'flex', flexDirection: 'column' }}>
        <NavLink to="/dashboard" className="sidebar-link">🏠 Dashboard</NavLink>
        <NavLink to="/wizard" className="sidebar-link">➕ New Campaign</NavLink>
        <NavLink to="/tracker" className="sidebar-link">📊 Tracker</NavLink>
      </nav>
      
      <button 
        className="logout-btn-sidebar"
        onClick={() => { localStorage.clear(); window.location.href='/login'; }}
      >
        Logout
      </button>
    </div>
  );
};

export default Sidebar;